export const DYNAMIC_CLIENT_SALES_AMOUNT_CATMAN_KPIS = [
    'cardholder_sales_amount_previous',
    'cardholder_sales_amount_with_promo_previous',
    'cardholder_sales_amount_without_promo_previous',
    'cardholder_sales_amount_lost_previous',
    'cardholder_sales_amount_lost_with_promo_previous',
    'cardholder_sales_amount_lost_without_promo_previous',
    'cardholder_sales_amount_regular',
    'cardholder_sales_amount_regular_delta',
    'cardholder_sales_amount_regular_evolution',
    'cardholder_sales_amount_regular_with_promo',
    'cardholder_sales_amount_regular_without_promo',
    'cardholder_sales_amount_regular_with_promo_evolution',
    'cardholder_sales_amount_regular_without_promo_evolution',
    'cardholder_sales_amount_regular_with_promo_delta',
    'cardholder_sales_amount_regular_without_promo_delta',
    'cardholder_sales_amount_new',
    'cardholder_sales_amount_new_without_promo',
    'cardholder_sales_amount_new_with_promo',
    'cardholder_sales_amount',
    'cardholder_sales_amount_delta',
    'cardholder_sales_amount_with_promo',
    'cardholder_sales_amount_with_promo_evolution',
    'cardholder_sales_amount_with_promo_delta',
    'cardholder_sales_amount_without_promo',
    'cardholder_sales_amount_without_promo_evolution',
    'cardholder_sales_amount_without_promo_delta',
    'cardholder_sales_amount_lost_in_brand_only_previous',
    'cardholder_sales_amount_lost_in_category_for_you_previous',
    'cardholder_sales_amount_lost_to_category_all_competitors_previous',
    'cardholder_sales_amount_lost_in_brand_only_with_promo_previous',
    'cardholder_sales_amount_lost_in_category_for_you_with_promo_previous',
    'cardholder_sales_amount_lost_to_category_all_competitors_with_promo_previous',
    'cardholder_sales_amount_lost_in_brand_only_without_promo_previous',
    'cardholder_sales_amount_lost_in_category_for_you_without_promo_previous',
    'cardholder_sales_amount_lost_to_category_all_competitors_without_promo_previous',
    'cardholder_sales_amount_new_in_brand_only',
    'cardholder_sales_amount_new_in_category_for_you',
    'cardholder_sales_amount_new_to_category_all_competitors',
    'cardholder_sales_amount_new_in_brand_only_with_promo',
    'cardholder_sales_amount_new_in_category_for_you_with_promo',
    'cardholder_sales_amount_new_to_category_all_competitors_with_promo',
    'cardholder_sales_amount_new_in_brand_only_without_promo',
    'cardholder_sales_amount_new_in_category_for_you_without_promo',
    'cardholder_sales_amount_new_to_category_all_competitors_without_promo',
    'cardholder_sales_amount_by_movement',
    'cardholder_sales_amount_by_movement_with_promo',
    'cardholder_sales_amount_by_movement_without_promo',
    'cardholder_sales_amount_by_movement_evolution',
    'cardholder_sales_amount_by_movement_with_promo_evolution',
    'cardholder_sales_amount_by_movement_without_promo_evolution'
];
export const DYNAMIC_CLIENT_SALES_AMOUNT_KPI_DISPLAY_NAME = [
    'dynamic_client_cardholder_sales_amount_previous',
    'dynamic_client_cardholder_sales_amount_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_previous',
    'dynamic_client_cardholder_sales_amount_lost_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_regular',
    'dynamic_client_cardholder_sales_amount_regular_delta',
    'dynamic_client_cardholder_sales_amount_regular_evolution',
    'dynamic_client_cardholder_sales_amount_regular_with_promo',
    'dynamic_client_cardholder_sales_amount_regular_without_promo',
    'dynamic_client_cardholder_sales_amount_regular_with_promo_evolution',
    'dynamic_client_cardholder_sales_amount_regular_without_promo_evolution',
    'dynamic_client_cardholder_sales_amount_regular_with_promo_delta',
    'dynamic_client_cardholder_sales_amount_regular_without_promo_delta',
    'dynamic_client_cardholder_sales_amount_new',
    'dynamic_client_cardholder_sales_amount_new_without_promo',
    'dynamic_client_cardholder_sales_amount_new_with_promo',
    'dynamic_client_cardholder_sales_amount',
    'dynamic_client_cardholder_sales_amount_evolution',
    'dynamic_client_cardholder_sales_amount_delta',
    'dynamic_client_cardholder_sales_amount_with_promo',
    'dynamic_client_cardholder_sales_amount_with_promo_evolution',
    'dynamic_client_cardholder_sales_amount_with_promo_delta',
    'dynamic_client_cardholder_sales_amount_without_promo',
    'dynamic_client_cardholder_sales_amount_without_promo_evolution',
    'dynamic_client_cardholder_sales_amount_without_promo_delta',
    'dynamic_client_cardholder_sales_amount_lost_in_brand_only_previous',
    'dynamic_client_cardholder_sales_amount_lost_in_category_for_you_previous',
    'dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_previous',
    'dynamic_client_cardholder_sales_amount_lost_in_brand_only_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_in_category_for_you_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_with_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_in_brand_only_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_in_category_for_you_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_without_promo_previous',
    'dynamic_client_cardholder_sales_amount_new_in_brand_only',
    'dynamic_client_cardholder_sales_amount_new_in_category_for_you',
    'dynamic_client_cardholder_sales_amount_new_to_category_all_competitors',
    'dynamic_client_cardholder_sales_amount_new_in_brand_only_with_promo',
    'dynamic_client_cardholder_sales_amount_new_in_category_for_you_with_promo',
    'dynamic_client_cardholder_sales_amount_new_to_category_all_competitors_with_promo',
    'dynamic_client_cardholder_sales_amount_new_in_brand_only_without_promo',
    'dynamic_client_cardholder_sales_amount_new_in_category_for_you_without_promo',
    'dynamic_client_cardholder_sales_amount_new_to_category_all_competitors_without_promo',
    'cardholder_sales_amount_by_movement',
    'cardholder_sales_amount_by_movement_with_promo',
    'cardholder_sales_amount_by_movement_without_promo',
    'cardholder_sales_amount_by_movement_comparison',
    'cardholder_sales_amount_by_movement_with_promo_comparison',
    'cardholder_sales_amount_by_movement_without_promo_comparison',
    'cardholder_sales_amount_by_movement_benchmark',
    'cardholder_sales_amount_by_movement_with_promo_benchmark',
    'cardholder_sales_amount_by_movement_without_promo_benchmark'
];
export const DYNAMIC_CLIENT_SALES_AMOUNT_KPI_MAPPING = {
    dynamic_client_cardholder_sales_amount_previous: 'cardholder_sales_amount_previous',
    dynamic_client_cardholder_sales_amount_with_promo_previous: 'cardholder_sales_amount_with_promo_previous',
    dynamic_client_cardholder_sales_amount_without_promo_previous: 'cardholder_sales_amount_without_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_previous: 'cardholder_sales_amount_lost_previous',
    dynamic_client_cardholder_sales_amount_lost_with_promo_previous: 'cardholder_sales_amount_lost_with_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_without_promo_previous: 'cardholder_sales_amount_lost_without_promo_previous',
    dynamic_client_cardholder_sales_amount_regular: 'cardholder_sales_amount_regular',
    dynamic_client_cardholder_sales_amount_regular_delta: 'cardholder_sales_amount_regular_delta',
    dynamic_client_cardholder_sales_amount_regular_evolution: 'cardholder_sales_amount_regular_evolution',
    dynamic_client_cardholder_sales_amount_regular_with_promo: 'cardholder_sales_amount_regular_with_promo',
    dynamic_client_cardholder_sales_amount_regular_without_promo: 'cardholder_sales_amount_regular_without_promo',
    dynamic_client_cardholder_sales_amount_regular_with_promo_evolution: 'cardholder_sales_amount_regular_with_promo_evolution',
    dynamic_client_cardholder_sales_amount_regular_without_promo_evolution: 'cardholder_sales_amount_regular_without_promo_evolution',
    dynamic_client_cardholder_sales_amount_regular_with_promo_delta: 'cardholder_sales_amount_regular_with_promo_delta',
    dynamic_client_cardholder_sales_amount_regular_without_promo_delta: 'cardholder_sales_amount_regular_without_promo_delta',
    dynamic_client_cardholder_sales_amount_new: 'cardholder_sales_amount_new',
    dynamic_client_cardholder_sales_amount_new_without_promo: 'cardholder_sales_amount_new_without_promo',
    dynamic_client_cardholder_sales_amount_new_with_promo: 'cardholder_sales_amount_new_with_promo',
    dynamic_client_cardholder_sales_amount: 'cardholder_sales_amount',
    dynamic_client_cardholder_sales_amount_evolution: 'cardholder_sales_amount_evolution',
    dynamic_client_cardholder_sales_amount_delta: 'cardholder_sales_amount_delta',
    dynamic_client_cardholder_sales_amount_with_promo: 'cardholder_sales_amount_with_promo',
    dynamic_client_cardholder_sales_amount_with_promo_evolution: 'cardholder_sales_amount_with_promo_evolution',
    dynamic_client_cardholder_sales_amount_with_promo_delta: 'cardholder_sales_amount_with_promo_delta',
    dynamic_client_cardholder_sales_amount_without_promo: 'cardholder_sales_amount_without_promo',
    dynamic_client_cardholder_sales_amount_without_promo_evolution: 'cardholder_sales_amount_without_promo_evolution',
    dynamic_client_cardholder_sales_amount_without_promo_delta: 'cardholder_sales_amount_without_promo_delta',
    dynamic_client_cardholder_sales_amount_lost_in_brand_only_previous: 'cardholder_sales_amount_lost_in_brand_only_previous',
    dynamic_client_cardholder_sales_amount_lost_in_category_for_you_previous: 'cardholder_sales_amount_lost_in_category_for_you_previous',
    dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_previous: 'cardholder_sales_amount_lost_to_category_all_competitors_previous',
    dynamic_client_cardholder_sales_amount_lost_in_brand_only_with_promo_previous: 'cardholder_sales_amount_lost_in_brand_only_with_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_in_category_for_you_with_promo_previous: 'cardholder_sales_amount_lost_in_category_for_you_with_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_with_promo_previous: 'cardholder_sales_amount_lost_to_category_all_competitors_with_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_in_brand_only_without_promo_previous: 'cardholder_sales_amount_lost_in_brand_only_without_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_in_category_for_you_without_promo_previous: 'cardholder_sales_amount_lost_in_category_for_you_without_promo_previous',
    dynamic_client_cardholder_sales_amount_lost_to_category_all_competitors_without_promo_previous: 'cardholder_sales_amount_lost_to_category_all_competitors_without_promo_previous',
    dynamic_client_cardholder_sales_amount_new_in_brand_only: 'cardholder_sales_amount_new_in_brand_only',
    dynamic_client_cardholder_sales_amount_new_in_category_for_you: 'cardholder_sales_amount_new_in_category_for_you',
    dynamic_client_cardholder_sales_amount_new_to_category_all_competitors: 'cardholder_sales_amount_new_to_category_all_competitors',
    dynamic_client_cardholder_sales_amount_new_in_brand_only_with_promo: 'cardholder_sales_amount_new_in_brand_only_with_promo',
    dynamic_client_cardholder_sales_amount_new_in_category_for_you_with_promo: 'cardholder_sales_amount_new_in_category_for_you_with_promo',
    dynamic_client_cardholder_sales_amount_new_to_category_all_competitors_with_promo: 'cardholder_sales_amount_new_to_category_all_competitors_with_promo',
    dynamic_client_cardholder_sales_amount_new_in_brand_only_without_promo: 'cardholder_sales_amount_new_in_brand_only_without_promo',
    dynamic_client_cardholder_sales_amount_new_in_category_for_you_without_promo: 'cardholder_sales_amount_new_in_category_for_you_without_promo',
    dynamic_client_cardholder_sales_amount_new_to_category_all_competitors_without_promo: 'cardholder_sales_amount_new_to_category_all_competitors_without_promo',
    cardholder_sales_amount_by_movement: 'cardholder_sales_amount_by_movement',
    cardholder_sales_amount_by_movement_with_promo: 'cardholder_sales_amount_by_movement_with_promo',
    cardholder_sales_amount_by_movement_without_promo: 'cardholder_sales_amount_by_movement_without_promo',
    cardholder_sales_amount_by_movement_comparison: 'cardholder_sales_amount_by_movement_evolution',
    cardholder_sales_amount_by_movement_with_promo_comparison: 'cardholder_sales_amount_by_movement_with_promo_evolution',
    cardholder_sales_amount_by_movement_without_promo_comparison: 'cardholder_sales_amount_by_movement_without_promo_evolution',
    cardholder_sales_amount_by_movement_benchmark: 'cardholder_sales_amount_evolution',
    cardholder_sales_amount_by_movement_with_promo_benchmark: 'cardholder_sales_amount_with_promo_evolution',
    cardholder_sales_amount_by_movement_without_promo_benchmark: 'cardholder_sales_amount_without_promo_evolution'
};
export const DYNAMIC_CLIENT_SALES_AMOUNT_DATA_TABLE_KPI_DISPLAY_NAME = [
    'cardholder_sales_amount_by_movement',
    'cardholder_sales_amount_by_movement_with_promo',
    'cardholder_sales_amount_by_movement_without_promo',
    'cardholder_sales_amount_by_movement_benchmark',
    'cardholder_sales_amount_by_movement_with_promo_benchmark',
    'cardholder_sales_amount_by_movement_without_promo_benchmark'
];
//# sourceMappingURL=salesAmount.kpis.js.map